import {
  CarIcon,
  Coins,
  ReceiptText,
  Star,
  type LucideIcon,
} from "lucide-react";

import { PaymentType } from "@/api-v3";
import { cn } from "@/lib/utils";

const ICON: Record<PaymentType, LucideIcon> = {
  [PaymentType.mileage_claim]: CarIcon,
  [PaymentType.receipt_claim]: ReceiptText,
  [PaymentType.micropayment]: Coins,
  [PaymentType.stipend]: Star,
};

interface PaymentTypeIconProps {
  type: PaymentType;
  className?: string;
}

export const PaymentTypeIcon = ({ type, className }: PaymentTypeIconProps) => {
  const Icon = ICON[type];
  return (
    <div
      aria-hidden="true"
      className={cn(
        "flex items-center justify-center h-10 w-10 rounded-full bg-slate-100 text-slate-500 shrink-0",
        className
      )}
    >
      <Icon className="h-5 w-5" />
    </div>
  );
};
